import React from 'react';

import { Tooltip, Fade } from '@material-ui/core';

export default function ValidationLengthCard(
  data,
  charactersCount,
  {
    noTooltip = false,
    fontBold = false,
    maxWidth,
    tooltipText = '',
    className = 'title',
    disablePortal = false,
    placement,
    fontSize = '16px',    
    style: extraStyle = {}
  } = {}
) {
  const needsTrim = (data?.length || 0) > charactersCount;
  const shown = needsTrim ? `${data.substring(0, charactersCount)}...` : data;

  const style = {
    display: 'inline',      
    maxWidth: maxWidth || 'inherit',
    minWidth: maxWidth || 'inherit',
    fontWeight: fontBold ? 'bold' : 'inherit',
    fontSize,   
    ...extraStyle
  };

  const Node = (
    <span className={className} style={style}>
      {shown}
    </span>
  );

  if (!needsTrim || noTooltip) return Node;

  return (
    <Tooltip
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      enterTouchDelay={0}
      title={tooltipText || data}
      disablePortal={disablePortal}
      placement={placement}
    >
      {Node}
    </Tooltip>
  );
}
